import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { TABLE_DRAWER_WIDTH } from 'const';

export const useCombinedTableControlsStyles = makeStyles(({ spacing, palette }) =>
  createStyles({
    drawer: {
      width: TABLE_DRAWER_WIDTH,
      overflowX: 'hidden',
      '& input': {
        boxSizing: 'content-box',
      },
      boxShadow: '-3px 1px 4px -1px rgb(0 0 0 / 36%)',
    },
    filterContainer: {
      padding: `${spacing(2)}`,
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    buttonGroup: {
      '& button': {
        borderColor: '#E0E0E0',
        color: palette.mode === 'light' ? palette.text.secondary : palette.common.white,
        padding: spacing(),
        paddingLeft: spacing(),
        paddingRight: spacing(),
        minWidth: '0 !important',
        width: 30,
        boxSizing: 'border-box',
        '&.active': {
          color: palette.primary.main,
          backgroundColor: palette.primary.light,
        },
      },
    },
    divider: {
      backgroundColor: '#DDD',
    },
  })
);
